<template>
  <div class="form_group">
    <div class="status-error" v-if="hasError('cc-stripe')"> {{ getErrorMessage( 'cc-stripe' ) }}</div>
    <label for="payment-cc-number">{{ copydeck.component_payment.txt_secure_credit_card_number[ lang ] }}&nbsp;:</label>
    <input type="tel"
           id="payment-cc-number"
           name="payment-cc-number"
           inputmode="numeric"
           pattern="[0-9\s]{13,19}"
           autocomplete="cc-number"
           maxlength="19"
           placeholder="xxxx xxxx xxxx xxxx" required="" v-model="creditcard.number">

    <div class="status-error"
         :aria-hidden="!hasError('payment-cc-number')"
         v-show="hasError('payment-cc-number')"> {{ getErrorMessage( 'payment-cc-number' ) }}
    </div>

  </div>
  <!-- div.form_group -->

  <div class="form_group cc_dates_group" aria-labelledby="payment-cc-dates">
    <div id="payment-cc-dates" class="label">{{ copydeck.component_payment.txt_secure_expiration_date[ lang ] }}&nbsp;&nbsp;:</div>

    <div class="payment-cc-date-fields">
      <input type="tel"
             inputmode="numeric"
             class="date-field payment-cc-month"
             id="payment-cc-month"
             name="payment-cc-month"
             pattern="[0-9]{2}"
             maxlength="2"
             :placeholder="copydeck.component_payment.placeholder_month[lang]" required=""
             v-model="creditcard.expiry_month">

      <input type="tel"
             inputmode="numeric"
             class="date-field payment-cc-year"
             id="payment-cc-year"
             name="payment-cc-year"
             pattern="[0-9]{4}"
             maxlength="4"
             :placeholder="copydeck.component_payment.placeholder_year[lang]" required=""
             v-model="creditcard.expiry_year">
    </div>


    <div class="status-error"
         :aria-hidden="!hasError('payment-cc-dates')"
         v-show="hasError('payment-cc-dates')"> {{ getErrorMessage( 'payment-cc-dates' ) }}
    </div>
  </div>
  <!-- div.form_group -->

  <div class="form_group">
    <label for="payment-cc-cvv">{{ copydeck.component_payment.txt_secure_ccv[ lang ] }}:</label>
    <input type="tel"
           inputmode="numeric"
           pattern="[0-9]{3,4}"
           id="payment-cc-cvv"
           name="payment-cc-cvv"
           maxlength="4"
           required="" v-model="creditcard.cvv">

    <div class="status-error"
         :aria-hidden="!hasError('payment-cc-cvv')"
         v-show="hasError('payment-cc-cvv')"> {{ getErrorMessage( 'payment-cc-cvv' ) }}
    </div>
  </div>
  <!-- div.form_group -->
</template>

<script>
export default {
  name : "GlobalPaymentCardInfo",
}
</script>

<script setup>

import { onMounted }    from "vue";
import { useMainStore } from "../stores/main";
import { storeToRefs }  from "pinia";

import {
  isValid,
  isExpirationDateValid,
  isSecurityCodeValid,
  getCreditCardNameByNumber,
} from 'creditcard.js';

defineExpose( { validateCreditInfo } );

let props                                   = defineProps( [ "errors" ] );
let store                                   = useMainStore();
let { copydeck, lang, invoice, creditcard } = storeToRefs( store );
let {}                                      = store;

function findError (strKey)
{
    let errors = props?.errors ?? [];

    if (errors.length === 0)
        return undefined;

    let strError = errors[strKey]

    if (strError !== undefined)
        return strError;

    if (!Array.isArray(errors))
        return undefined;

    let error = errors.find((error) =>
                            {

                                let props = Object.keys(error);

                                for (let i = 0; i < props.length; i++)
                                {
                                    if (props[i] === strKey)
                                        return Object.values(strKey)[i];
                                }

                                return false;

                            });


    if (!error)
        return undefined;

    return error[strKey];
}
function hasError ( strKey )
{
  let strError = findError(strKey)

  if ( strError === undefined )
    return false;


  return strError !== "";
}

function getErrorMessage ( strKey )
{
    let strError = findError(strKey)

  if ( copydeck.value.form_errors[ strError ] )
  {
    return copydeck.value.form_errors[ strError ][ lang.value ];
  }

  return "";
}

function checkErrorClass ( strKey )
{
  return hasError( strKey ) ? "status-error" : "";
}

function validateCreditInfo ()
{
  let validCCNumber = isValid( creditcard.value.number ?? '' );
  let validExpiry   = isExpirationDateValid( creditcard.value.expiry_month ?? '', creditcard.value.expiry_year ?? '' )
  let validCVC      = isSecurityCodeValid( creditcard.value.number ?? '', creditcard.value.cvv ?? '' );
  let ccName        = getCreditCardNameByNumber( creditcard.value.number ?? '' );

  let ccType     = { "VI" : "Visa", "MC" : "Mastercard" };
  let debug      = ccType[ creditcard.value.type ];
  let isSameType = ccName === ccType[ creditcard.value.type ?? '' ];

  let output = { success : true, errors : {} };

  if ( !validCCNumber )
  {
    output.success                       = false;
    output.errors[ "payment-cc-number" ] = "credit_card_number_is_invalid";
  } else if ( !isSameType )
  {
    output.success                       = false;
    output.errors[ "payment-cc-number" ] = "credit_card_number_wrong_type";
  }

  if ( !validExpiry )
  {
    output.success                      = false;
    output.errors[ "payment-cc-dates" ] = "expiry_date_invalid";
  }

  if ( !validCVC )
  {
    output.success                    = false;
    output.errors[ "payment-cc-cvv" ] = "incorrect_cvc";
  }

  return output;
}


</script>
